export const applyStyle = (
  id: string,
  styles?: {
    vars?: Record<string, number | string>
    rules?: string
  }
) => {
  let styleEl = document.getElementById(id) as HTMLStyleElement

  if (styleEl) {
    if (!!styleEl?.sheet?.cssRules?.length) {
      for (const index in styleEl.sheet?.cssRules) {
        if (Object.prototype.hasOwnProperty.call(styleEl.sheet?.cssRules, index)) {
          styleEl.sheet.deleteRule(+index)
        }
      }
    }
  } else {
    styleEl = document.createElement('style')
    styleEl.id = id
    document.querySelector('head')?.appendChild(styleEl)
  }

  if (styles?.vars) {
    const vars: string[] = []
    Object.entries(styles.vars).forEach(([key, value]) => {
      vars.push(` ${key}:${value}`)
    })
    styleEl.sheet?.insertRule(`:root {${vars.join(';')}}`)
  }

  if (styles?.rules) styleEl.sheet?.insertRule(styles.rules)
}

export const loadStyleLink = (id: string, src: string) => {
  let linkEl = document.getElementById(id) as HTMLLinkElement

  if (!linkEl) {
    linkEl = document.createElement('link')
    linkEl.setAttribute('id', id)
    linkEl.setAttribute('rel', 'stylesheet')
    document.querySelector('head')?.appendChild(linkEl)
  }

  linkEl.setAttribute('href', src)
}

export const setAppStyle = (params: Record<string, any>) => {
  const normalizeImagePath = (image: string): string => {
    const trimmed = (image || '').trim().replace(/\/\.\//g, '/').replace(/^\.\//, '')
    if (!trimmed) return ''
    if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
      return trimmed
    }

    const relativePath = trimmed.startsWith('/') ? trimmed : `./${trimmed}`
    return new URL(relativePath, window.location.href).toString()
  }

  if ('color' in params) {
    const color = params.color?.slice(0, 2) === '--' ? `var(${params.color})` : params.color
    document.body.style.setProperty('--app-background-color', color || '')
  }

  if ('image' in params) {
    const image = normalizeImagePath(params.image)
    document.body.style.setProperty('--app-background-image', image ? `url(${image})` : '')
  }
}
